export const areAllPredicatesFulfilled = (predicateResults: boolean[]): boolean => {
  return predicateResults.every((predicateResult) => {
    return predicateResult === true;
  });
};

export const isAtLeastOnePredicateFulfilled = (predicateResults: boolean[]): boolean => {
  return predicateResults.some((predicateResult) => predicateResult === true);
};
